export interface ToggleBoldResult {
  text: string;
  selFrom: number;
  selTo: number;
}

/**
 * Toggles **bold** markers around the [from, to) selection of `doc`.
 * Pure — returns the full new document text and the new selection range.
 */
export function toggleBold(doc: string, from: number, to: number): ToggleBoldResult {
  const selected = doc.slice(from, to);

  // Markers included in the selection: **…** → unwrap.
  if (selected.length >= 4 && selected.startsWith('**') && selected.endsWith('**')) {
    const inner = selected.slice(2, -2);
    return {
      text: doc.slice(0, from) + inner + doc.slice(to),
      selFrom: from,
      selTo: from + inner.length,
    };
  }

  // Markers just outside the selection: **|…|** → unwrap.
  if (doc.slice(Math.max(0, from - 2), from) === '**' && doc.slice(to, to + 2) === '**') {
    return {
      text: doc.slice(0, from - 2) + selected + doc.slice(to + 2),
      selFrom: from - 2,
      selTo: to - 2,
    };
  }

  // Empty selection: insert **** and place the cursor between the markers.
  if (from === to) {
    return {
      text: doc.slice(0, from) + '****' + doc.slice(to),
      selFrom: from + 2,
      selTo: from + 2,
    };
  }

  // Default: wrap the selection.
  return {
    text: doc.slice(0, from) + '**' + selected + '**' + doc.slice(to),
    selFrom: from + 2,
    selTo: to + 2,
  };
}
